const NAMESPACE = "name";

const KEYS = {
    firstNamePlaceholder: "firstNamePlaceholder",
    lastNamePlaceholder: "lastNamePlaceholder"
};

const MESSAGES = {
    [KEYS.firstNamePlaceholder]: {
        value: "First",
        comment: "Placeholder for input field for first name"
    },
    [KEYS.lastNamePlaceholder]: {
        value: "Last",
        comment: "Placeholder for input field for last name"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
